import { render, staticRenderFns } from "./BagCheckoutButton.vue?vue&type=template&id=15d1331c&"
import script from "./BagCheckoutButton.vue?vue&type=script&lang=js&"
export * from "./BagCheckoutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
